import React, { useContext, useState } from 'react'

import { useFeature } from '@optimizely/react-sdk'
import { compose } from 'recompose'

import { TIERED_FLOW } from 'app-constants'
import Separator from 'components/Separator'
import { ActionType, FunnelName, PageName } from 'generated/types'
import { WithFlowRouterProps, withFlowRouter } from 'utils/FlowProvider'
import { FlowRoute } from 'utils/FlowProvider/types'
import { FunnelContext } from 'utils/FunnelContext'
import { cardOrderReviewCorrection } from 'utils/Optimizely/features'

import { useCardOrderReviewErrorTracking } from './events'
import hardFailImage from './hard-fail.svg'
import {
  Content,
  ErrorImage,
  MessageHeader,
  MessageSection,
  MessageSubHeader,
  NextButton,
} from './styled-components'

const enhance = compose<WithFlowRouterProps, {}>(withFlowRouter)

export const HardFailScreen = enhance(({ setFlow, route }) => {
  const track = useCardOrderReviewErrorTracking()
  const { updateAttribution, isDynamicFunnelEnabled, routeToPage } = useContext(FunnelContext)
  const [isCardOrderReviewCorrectionEnabled] = useFeature(cardOrderReviewCorrection)
  const [submitting, setSubmitting] = useState(false)

  const handleSubmit = async () => {
    track.doneTapped()
    setSubmitting(true)
    await updateAttribution(FunnelName.Default)
    setFlow(TIERED_FLOW)

    if (isDynamicFunnelEnabled) {
      isCardOrderReviewCorrectionEnabled
        ? routeToPage(PageName.CardOrderReview, ActionType.Update)
        : routeToPage(PageName.InvestorQuestions, ActionType.Continue)
    } else {
      route({ from: FlowRoute.CardOrderReview, action: 'continue' })
    }

    setSubmitting(false)
  }

  return (
    <>
      <Content>
        <ErrorImage src={hardFailImage} alt="link funding source" />
        <MessageSection>
          <MessageHeader>Sorry about this</MessageHeader>
          <MessageSubHeader>
            You are ineligible to open an Acorns Checking account. However, you may be eligible for
            an Invest account. For more information, please contact customer support.
          </MessageSubHeader>
        </MessageSection>
      </Content>
      <Separator />
      <NextButton disabled={submitting} onPress={handleSubmit}>
        Continue to Invest
      </NextButton>
    </>
  )
})
